import React from 'react';
import RegistrationForm from '../Registration/RegistrationForm';

export default function RegistrationBrandingCard(props) {
	// console.log('RegistrationBrandingCard', props);
	return (
		<div className="RegistrationBrandingCard m-3 shadow">
			<div className="row" style={{ backgroundColor: '#27325a' }}>
				<div className="logo px-4">
					<img
						src="http://localhost:3000/packs/media/admin_theme/logo-dark-669b1502.png"
						alt={I18n.t('logo')}
					/>
				</div>
				<span className="text-white flex-self ml-auto mr-4 my-auto">
					<i className="fa fa-question-circle mx-1" aria-hidden="true" />Help
				</span>
			</div>
			<div className="row">
				<div className="col-6" style={{ backgroundColor: '#6c757d' }}>
					<div className="my-5 mx-4 py-5 px-4 text-white">
						<h2 className="text-white mb-3">
							{I18n.t('admin.registration_branding_title')}
						</h2>
						<p>{I18n.t('admin.registration_instructions')}</p>
						<p>{I18n.t('admin.registration_already_a_member')}</p>
					</div>
				</div>
				<div className="col-6 d-flex justify-content-start align-items-center " style={{ backgroundColor: 'white' }}>
					<RegistrationForm data={props.data} />
				</div>
			</div>
		</div>
	);
}
